import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { MINUTES_TO_MILLIS } from "lopermut"
import {
  ComparableMetricSchema,
  CustomersMetricResponseDataSchema,
  DataResponse,
  GetMetricSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetMetricSchema>
type Props = { query?: Query; enabled?: boolean }

type ComparableMetric = z.infer<typeof ComparableMetricSchema>
type CustomersMetric = z.infer<typeof CustomersMetricResponseDataSchema>

const STALE_TIME = 2 * MINUTES_TO_MILLIS

const buildMetricQuery =
  <T>(metric: string, path: string) =>
  (props: Props = {}) =>
    queryOptions({
      queryKey: ["dashboard-metrics", metric, JSON.stringify(props.query)],
      queryFn: async () => {
        const response = await axios.get<DataResponse<T>>(`/insights/metrics/${path}`, {
          params: props.query,
        })
        return response.data.data
      },
      staleTime: STALE_TIME,
      enabled: props.enabled,
    })

export const customersMetricQuery = buildMetricQuery<CustomersMetric>("customers", "customers")
export const npsMetricQuery = buildMetricQuery<ComparableMetric>("nps", "nps")
export const insightsCapturedMetricQuery = buildMetricQuery<ComparableMetric>(
  "insights-captured",
  "insights-captured",
)
export const deflectionRateMetricQuery = buildMetricQuery<ComparableMetric>(
  "deflection-rate",
  "deflection-rate",
)
export const hoursSavedMetricQuery = buildMetricQuery<ComparableMetric>(
  "hours-saved",
  "hours-saved",
)
export const issueDeflectionRateMetricQuery = buildMetricQuery<ComparableMetric>(
  "issue-deflection-rate",
  "issue-deflection-rate",
)
export const questionHoursSavedMetricQuery = buildMetricQuery<ComparableMetric>(
  "question-hours-saved",
  "question-hours-saved",
)
export const actionRequestHoursSavedMetricQuery = buildMetricQuery<ComparableMetric>(
  "action-request-hours-saved",
  "action-request-hours-saved",
)
